export default __webpack_public_path__ + "static/media/Ovato-Coins.6140b560.png";